module.exports = __webpack_public_path__ + "static/fonts/iconfont.1b93bde2.woff2";